import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import { combineClassNames } from 'core/css';
import { setSelectionRevealState } from '../../store/actions';
import Chat from '../../components/chat/Chat';
import { useModelInfo } from '../../common/ModelInfoContext';

export const FlexViewGrid = ({ className, children }) => (
  <section className={combineClassNames(['flex-view__grid', className])}>
    {children}
  </section>
);

export const FlexViewMain = ({ children }) => <main>{children}</main>;

const FlexView = ({ children, onLoad, bottomOffset }) => {
  const { hasTransactionId } = useModelInfo();

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div
      className="flex-view-container"
      style={{ paddingBottom: bottomOffset }}>
      {children}
      <div className="flex-view__footer-section">
        {!hasTransactionId && (
          <div className="flex-view__cta-container">
            <Chat />
          </div>
        )}
        <Footer className="flex-view__footer" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { isSelectionRevealed } = state;
  return {
    isSelectionRevealed,
  };
};

const mapDispatchToProps = {
  onLoad: () => setSelectionRevealState(),
};

export default connect(mapStateToProps, mapDispatchToProps)(FlexView);
